<template>
  <main class="container mailsend">
    <section class="wellcome-section">
      <p class="sub">Contact</p>
      <h1>Leave us a message</h1>
    </section>

    <section class="mailsend-section">
      <form class="form-area" @submit.prevent="handleSubmit">
        <div class="input-area">
          <label class="required">Full Name</label>
          <input type="text" v-model="name" />
        </div>

        <div class="input-area">
          <label class="required">Email</label>
          <input type="email" v-model="email" oninvalid="this.setCustomValidity(`Please include an '@' in the email address.`)" />
        </div>

        <div class="input-area">
          <label class="required">Phone number</label>
          <input type="text" inputmode="numeric" v-model="phone" />
        </div>

        <div class="input-area">
          <label class="required">Address</label>
          <input type="text" v-model="address" />
        </div>

        <div class="text-area">
          <label class="required">Message</label>
          <textarea v-model="message" rows="10"></textarea>
          <div :class="message !== '' ? 'place-holder none' : 'place-holder'">
            Enquiry / How can we help you? / <br class="mo_show" />What is your <br class="pc_show" />biggest pest concern?
          </div>
        </div>

        <button class="btn" type="submit">Send</button>
      </form>
    </section>
  </main>

  <ErrorModalView :modal-state="modalState" :modal-data="modalData" @close-modal="closeModal" />

  <LoadingView :is-loading="isLoading" />
</template>

<script setup>
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import ErrorModalView from '@/components/common/ErrorModalView.vue'
import LoadingView from '@/components/common/LoadingView.vue'
import api from '@/configs/api'

const route = useRoute()
const query = route.query

const name = ref('')
const email = ref('')
const phone = ref('')
const address = ref('')
const message = ref('')

const modalState = ref(false)
const modalData = ref(null)

const isLoading = ref(false)

const openModal = data => {
  modalData.value = data
  modalState.value = true
}

const closeModal = () => {
  modalData.value = null
  modalState.value = false
}

const handleSubmit = () => {
  if (!name.value || !email.value || !phone.value || !address.value || !message.value) {
    return openModal({
      type: 'error',
      content: 'Please enter the required information.'
    })
  }

  const data = {
    name: name.value, //이름
    senderEmail: email.value, //메일 주소
    content: message.value, //보낼 내용
    phoneNumber: phone.value.replace(/-/gi, ''), //전화번호
    address: address.value, //보낼 내용
    local: query.local //메일 구분값
  }

  isLoading.value = true

  api
    .post('/mail/contact/', data)
    .then(response => {
      if (response.status === 200) {
        openModal({
          type: 'success',
          content: 'Your message has been sent.'
        })
      }
    })
    .catch(() => {
      openModal({
        type: 'error',
        content: 'Please try again later.'
      })
    })
    .finally(() => {
      isLoading.value = false
    })
}

watch([isLoading, modalState], value => {
  value[0] || value[1] ? (document.body.style.overflow = 'hidden') : document.body.style.removeProperty('overflow')
})
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/mailsend.scss';
</style>
